import type { Region } from '@experiences/constants';

export enum MigrationAvailability {
    ENABLED = 'Enabled',
    SCHEDULED = 'Scheduled',
    RUNNING = 'Running',
    PENDINGFINALIZATION = 'PendingFinalization',
    PARTIALLYCOMPLETED = 'PartiallyCompleted',
    READYTOCOMPLETE = 'ReadyToComplete',
    COMPLETED = 'Completed',
}

export const MigrationStartWindowDays = 0;
export const MigrationEndWindowDays = 14;

export interface IMigrationResponse {
    instanceId: string;
}

// ts-unused-exports:disable-next-line
export type ScheduleType = 'Default' | 'Simple' | 'Flexible';

export interface IScheduleSlot {
    slotDate: string;
    isExpired?: boolean;
}

export interface IMigrationRequestBase {
    sourceRegion: Region;
    destinationRegion: Region;
    timeOfDayStartIntervalTicks: number;
    timeOfDayEndIntervalTicks: number;
}

export interface IEarliestMigrationRequest extends IMigrationRequestBase {
    scheduleType: 'Simple';
    scheduleStartDate: string;
    scheduleEndDate: string;
    slots?: undefined;
}

export interface IFlexibleMigrationRequest extends IMigrationRequestBase {
    scheduleType: 'Flexible';
    slots: string[];
    scheduleStartDate?: undefined;
    scheduleEndDate?: undefined;
}

export type IMigrationRequest = IEarliestMigrationRequest | IFlexibleMigrationRequest;

export interface IMigrationStatus {
    instanceId: string;
    sourceRegion: string;
    destinationRegion: string;
    scheduleEndDate: string;
    scheduleStartDate: string;
    status: string;
    timeOfDayEndIntervalTicks: number;
    timeOfDayStartIntervalTicks: number;
    scheduleType?: ScheduleType;
    slots?: IScheduleSlot[];
    hasMisalignedServices?: boolean;
    hasNonTerminalServices?: boolean;
    completedAt?: string;
}

export interface IServiceMigrationStatus {
    serviceName: string;
    status: 'Migrated' | 'Failed' | 'Running' | 'Pending' | 'AwaitingFix';
    errorMessage?: string;
    completedAt?: string;
    fixedAt?: string;
    operatorNotes?: string;
    retryable?: boolean;
}

export interface IMigrationProgress {
    status: string;
    sourceRegion: string;
    destinationRegion: string;
    startedAt?: string;
    services: IServiceMigrationStatus[];
    totalServices?: number;
    completedServices?: number;
    scheduleType?: ScheduleType;
    slots?: IScheduleSlot[];
}

interface IRetryMigrationRequestBase {
    timeOfDayStartIntervalTicks: number;
    timeOfDayEndIntervalTicks: number;
    scheduleStartDate: string;
    scheduleEndDate: string;
}

// ts-unused-exports:disable-next-line
export interface IEarliestRetryMigrationRequest extends IRetryMigrationRequestBase {
    scheduleType: 'Simple';
    slots?: undefined;
}

// ts-unused-exports:disable-next-line
export interface IFlexibleRetryMigrationRequest extends IRetryMigrationRequestBase {
    scheduleType: 'Flexible';
    slots: string[];
}

export type IRetryMigrationRequest = IEarliestRetryMigrationRequest | IFlexibleRetryMigrationRequest;

interface ITenantServiceRegion {
    service: string;
    region: Region;
}

export interface IRegionsPerService {
    availableRegionsPerService: Record<string, ITenantServiceRegion[]>;
}

export interface IOrganizationScheduledMigrationStats {
    hasOrganizationMigration: boolean;
    scheduledTenantIds: string[];
}

export interface IPartitionRegionIntent {
    partitionId: string;
    currentRegion: string;
    intendedRegion: string;
}

export interface IPartitionRegionIntentResponse extends IPartitionRegionIntent {
    organizationId: string;
    isMigrated: boolean;
}

export interface ShouldShowIntentionScreenResponse {
    shouldShow: boolean;
}
